import "./footer.css";

function footer() {
  return (
    <footer className="footer">
      <div className="copyright">
        <p>Copyright @2025 Global Tyres Recycling Ltd. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default footer;
